// export const backendUrl = "http://localhost:8000";
export const backendUrl = "https://gc-erp-system.onrender.com";
